import React, {Component} from 'react';

import '../styles/job-hero.css';

class JobHero extends Component {
    render() {
        return  <div className="job-hero">
                </div>
    }
};

export default JobHero;


// WEBPACK FOOTER //
// ./src/components/jobHero.js